import PropTypes from 'prop-types';
import classnames from 'classnames';

import style from './style.scss';

const Column = ({
  size,
  shrink,
  grow,
  noBreak,
  noGutter,
  className,
  children,
  ...restProps
}) => {
  const sizeClass = `col${size}`;
  const classes = classnames(style.column, className, style[sizeClass], {
    [style.shrink]: shrink,
    [style.grow]: grow,
    [style.noGutter]: noGutter,
    [style.noBreak]: noBreak,
  });
  return (
    <div className={classes} {...restProps}>
      {children}
    </div>
  );
};

Column.defaultProps = {
  size: 12,
  grow: false,
  shrink: false,
  noGutter: false,
  noBreak: false,
};

Column.propTypes = {
  size: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  className: PropTypes.string,
  grow: PropTypes.bool,
  shrink: PropTypes.bool,
  noGutter: PropTypes.bool,
  noBreak: PropTypes.bool,
};

export default Column;
